import { expectedAnswerType } from "@/entities/questionaire/answers/ExpectedAnswerType";

export class AnswerVariant {
  id: number;
  text: string;
  failed: boolean = false;
  expectedAnswer: expectedAnswerType;
  label?: string;
  scoringValues?: number[];
  constructor(
    id: number,
    text: string,
    expectedAnswer: expectedAnswerType = expectedAnswerType.none,
    label?: string,
    scoringValues?: number[]
  ) {
    this.id = id;
    this.text = text;
    this.expectedAnswer = expectedAnswer;
    this.label = label;
    this.scoringValues = scoringValues;
  }

  get isDataCompleted() {
    return this.expectedAnswer !== expectedAnswerType.none;
  }
}
